export default (() => {

  class HeaderCourseStickyV2 {
    constructor() {
      this.$courseHeader = $('.header-course-v2__panel');
      this.$courseHeaderSticky = $('.header-course-v2-sticky');
      this.$courseHeaderTopOffset = this.$courseHeader.offset().top;
      this.$courseHeaderHeight = this.$courseHeader.outerHeight();
      this.$viewportWidth = $(window).width();
    }

    scrolling() {
      var scrolledPastElement = this.$courseHeaderTopOffset + this.$courseHeaderHeight;
      if (this.$viewportWidth <= 991 && !this.$courseHeaderSticky.hasClass('kiosk')) {
        var scrolledPastElement = this.$courseHeaderTopOffset + this.$courseHeaderHeight - 60;
      }
      if ($(window).scrollTop() > (scrolledPastElement)) {
        this.$courseHeaderSticky.addClass('active');
      }
      else {
        this.$courseHeaderSticky.removeClass('active');
      }
    }

    init() {
      this.scrolling();
      $(document).on('scroll', () => this.scrolling());
    }
  }

  if ($('.header-course-v2__panel')[0]){
    const headerCourseSticky = new HeaderCourseStickyV2();
    headerCourseSticky.init()
  }

})()

